// extracted by mini-css-extract-plugin
export default {"root":"BaseLayout_root__C5cAy"};